import { api } from "@/lib/api";

export const createTicket = (payload) =>
  api
    .post(
      "/platform/support/tickets",
      payload
    )
    .then((response) => response.data);

export const listTickets = (params = {}) =>
  api
    .get(
      "/platform/support/tickets",
      { params }
    )
    .then((response) => response.data);

export const getTicket = (ticketId) =>
  api
    .get(
      `/platform/support/tickets/${ticketId}`
    )
    .then((response) => response.data);

export const updateTicket = (
  ticketId,
  payload
) =>
  api
    .patch(
      `/platform/support/tickets/${ticketId}`,
      payload
    )
    .then((response) => response.data);

export const listMyTickets = (params = {}) =>
  api
    .get(
      "/platform/support/my-tickets",
      { params }
    )
    .then((response) => response.data);

export const getMyTicket = (ticketId) =>
  api
    .get(
      `/platform/support/my-tickets/${ticketId}`
    )
    .then((response) => response.data);

export const addMessage = (ticketId, message) =>
  api
    .post(
      `/platform/support/tickets/${ticketId}/messages`,
      { message }
    )
    .then((response) => response.data);

export const sendReporterFeedback = (ticketId, payload) =>
  api
    .post(
      `/platform/support/my-tickets/${ticketId}/feedback`,
      payload
    )
    .then((response) => response.data);
